<script setup lang="ts">
import { toRefs } from 'vue';

export interface ChartLegendItemPropsInterface {
  className?: string;
  title: string;
  total?: string;
  color?: string;
}
const props = defineProps<ChartLegendItemPropsInterface>();
const { className, title, total, color } = toRefs(props);
</script>

<template>
  <div class="grid py-1 pl-1 w-full" :class="className" :style="{ color }">
    <div v-if="total" class="col-fixed m-0 mx-3 p-0 total">
      <span class="text-lg font-semibold" v-text="total" />
    </div>
    <div class="col m-0 p-0">
      <span class="inline-block text-sm" style="margin-top: 2px" v-text="title"></span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.total {
  width: 24px;
}
</style>
